import { createContext } from "react";

const SidebarContext = createContext({
  expanded: true,
  setExpanded: () => {},
  sidebarWidth: 270,
  isMobile: false,
  isTablet: false
});

export default SidebarContext;
